<template>
  <div class="ins-main contact-main">
    <section class="header clearfix">
      <div class="header_inner">
        <span>{{$t('lang_men_contact')}}</span
        ><nav class="cantact-info">
          <div class="cantact-info-business">
            <div>{{$t('lang_footer_service')}}</div>
            <div>
              <span class="font-Eco"><i class="icon-27"></i><i class="icon-mail"></i>sales@rollingbet.com</span>
            </div>
          </div>
          <div class="cantact-info-time">
            <span>{{$t('lang_footer_serviceTime')}}</span>
            <span>AM 09:00 - PM 06:00</span>
          </div>
          <div class="cantact-info-technology">
            <span>{{$t('lang_footer_support')}}</span>
            <span class="font-Eco"><i class="icon-27"></i><i class="icon-mail"></i>info@rollingbet.com</span>
          </div>
        </nav>
      </div>
    </section>
    <section class="cantact-map">
      <div class="cantact-bg cantact-bg-t"><img src="@img/contact/content_map.jpg"></div>
      <div class="cantact-coordinate" v-html="$t('lang_contact_address')"></div>
      <form name="contact_form" id="contact_form" method="post">
        <div class="cantact-form">
          <h1>{{$t('lang_contact_title')}}</h1>
          <h2 v-html="$t('lang_contact_msg')"></h2>
          <div class="cantact-inner clearfix">
            <label class="cantact-comp" :class="{active:isActive===1}">
              <input type="text" name="company" v-model="company" @focus='moveOut(1)' @blur='moveIn'>
              <span v-show="!company">{{$t('lang_company')}}</span>
              <span class="text-prompt" v-show="dataValCompany && isSend">{{$t("lang_required_field")}}</span>
            </label>
            <label class="cantact-title" :class="{active:isActive===2}">
              <input type="text" name="name" v-model="title" @focus='moveOut(2)' @blur='moveIn'>
              <span v-show="!title">{{$t('lang_name')}}</span>
              <span class="text-prompt" v-show="dataValTitle && isSend">{{$t("lang_required_field")}}</span>
            </label>
            <label class="cantact-tel" :class="{active:isActive===3}">
              <input type="text" name="phone" v-model="tel" @focus='moveOut(3)' @blur='moveIn("tel")'>
              <span v-show="!tel">{{$t('lang_phoneNumber')}}</span>
              <span class="text-prompt" v-show="dataValTel && isSend">{{$t("lang_required_field")}}</span>
              <span class="text-prompt" v-show="dataform.tel && !dataValTel">{{$t("lang_email_tel")}}</span>
            </label>
            <label class="cantact-mail" :class="{active:isActive===4}">
              <input type="text" name="email" v-model="email" @focus='moveOut(4)' @blur='moveIn("email")'>
              <span v-show="!email">{{$t('lang_mail')}}</span>
              <span class="text-prompt" v-show="dataValEmail && isSend">{{$t("lang_required_field")}}</span>
              <span class="text-prompt" v-show="dataform.email && !dataValEmail">{{$t("lang_email_error")}}</span>
            </label>
            <label class="cantact-msg" :class="{active:isActive===5}">
              <textarea name="message" @focus='moveOut(5)' @blur='moveIn' v-model="message"></textarea>
              <span v-show="!message">{{$t('lang_message')}}</span>
              <span class="text-prompt" v-show="dataValMessage && isSend">{{$t("lang_required_field")}}</span>
            </label>
            <button type="button" id="send" class="btn-send" @click="send">{{$t('lang_send')}}</button>
          </div>
        </div>
      </form>
    </section>
    <div class="cantact-bg cantact-bg-p" v-html="$t('lang_contact_address')"></div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import {BACKEND_LOCATION} from '@api/Endpoints'
import jqueryparam from 'jquery-param'
export default {
  name: 'Contact',
  data(){
    return{
      isActive: 0,
      title:"",
      tel:"",
      company:"",
      email:"",
      message:"",
      dataform: {
        "tel":false,
        "email":false
      },
      isSend: false
    }
  },
  computed: {
    ...mapGetters({
      nowLangx: "nowLangx",
    }),
    dataValCompany: function(){
      return this.company === '' ? true:false
    },
    dataValTitle: function(){
      return this.title === '' ? true:false
    },
    dataValTel: function(){
      return this.tel === '' ? true:false
    },
    dataValEmail: function(){
      return this.email === '' ? true:false
    },
    dataValMessage: function(){
      return this.message === '' ? true:false
    }
  },
  methods: {
    moveOut(value){
      this.isActive = value
      if(value === 3){
        this.dataform.tel = false
      }else if (value === 4){
        this.dataform.email = false
      }
    },
    moveIn(ver){
      const $this = this
      this.isActive = 0
      if(ver === 'email' && this.email){
        this.IsEmail(this.email)
      }else if(ver === 'tel' && this.tel){
        this.IsTel(this.tel)
      }
    },
    dataReset(){
      this.isSend = false
      this.isActive = 0
      this.title = ''
      this.tel = ''
      this.company = ''
      this.email = ''
      this.message = ''
      this.$set(this.dataform,"tel",false)
      this.$set(this.dataform,"email",false)
    },
    send(){
      const $this = this
      this.isSend = true
      if($this.dataform.tel || $this.dataform.email) { return }
      const sendData = {
        "title":$this.title,
        "company":$this.company,
        "email":$this.email,
        "tel":$this.tel,
        "message":$this.message,
        "id_tb_language": $this.nowLangx
      }

      for(var obj in sendData) {
        if(sendData[obj] === '') return
      }

      const api = BACKEND_LOCATION.api + 'contact'
      const config = {
        headers: { 'content-type': 'application/x-www-form-urlencoded' }
      }
      const nextData = jqueryparam(sendData)
      axios.post(api,nextData,config)
      .then(function (response) {
        const res = response.data
        const code = res.code
        switch(code){
          case "100":
            alert($this.$t('lang_contact_sendSuccess'))
            $this.dataReset()
            break
          case "101":
            alert($this.$t('lang_contact_send30slater'))
            $this.dataReset()
            break
          default:
            console.log('error')
            break
        }
      })
      .catch(function (error) {
        console.log(error);
      });
      
    },
    IsEmail(email) {
      console.log(email)
      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      this.dataform.email = !regex.test(email);
    },
    IsTel(tel) {
      const regex =  /^\d+$/;
      this.dataform.tel = !regex.test(tel);
    }
  },
  mounted(){
    this.dataReset()
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>

<style lang="sass">
    @import '@css/contact.sass'
</style>
